export default __webpack_public_path__ + "static/media/skippedmeal_6@2x.b7571c72.jpg";